export const RadonLevel = {
  UNKNOWN: 0,
  MODERATE: 1,
  HIGH: 2,
  VERYHIGH: 3,
};
